var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_1357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3115 2.4164L12.9506 9.72183M16.0854 7.30609L15.8181 4.2511C15.753 3.5072 15.7205 3.13525 15.5508 2.86379C15.4016 2.625 15.1806 2.43958 14.9196 2.3341C14.6228 2.21419 14.2508 2.24673 13.5069 2.31181L6.41271 2.93248C5.44209 3.0174 4.95679 3.05986 4.58035 3.27176C4.24858 3.45852 3.97701 3.7361 3.79755 4.07188C3.59393 4.45287 3.5621 4.93899 3.49844 5.91122L3.34861 8.19966C3.26464 9.48198 3.22266 10.1231 3.45349 10.599C3.65609 11.0166 3.99765 11.3508 4.41963 11.5442C4.9004 11.7646 5.54049 11.7086 6.82067 11.5966L7.35534 11.5498C7.72728 11.5172 7.91326 11.501 8.06165 11.5609C8.19219 11.6137 8.30268 11.7064 8.37728 11.8258C8.4621 11.9615 8.47837 12.1475 8.51091 12.5194L8.68139 14.4681C8.76052 15.3725 9.55786 16.0416 10.4623 15.9624C10.678 15.9436 10.8624 15.7994 10.9328 15.5946L12.7254 10.3774C12.8069 10.1401 12.8477 10.0215 12.9206 9.9307C12.985 9.85047 13.0672 9.78625 13.1606 9.74307C13.2663 9.69422 13.3912 9.68328 13.6412 9.66141L14.1461 9.61724C14.89 9.55216 15.2619 9.51962 15.5334 9.34999C15.7722 9.20078 15.9576 8.9798 16.0631 8.71873C16.183 8.42194 16.1504 8.04999 16.0854 7.30609Z",
    stroke: "#F04438",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_1357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.905029 2.07593) rotate(-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisLike);
export default __webpack_public_path__ + "static/media/disLike.1759dbeacf3f90324d1832f7e205f04b.svg";
export { ForwardRef as ReactComponent };